module.exports = __webpack_public_path__ + "img/setup-step-one.23262722.svg";